module.exports = __webpack_public_path__ + "96a3518447564a9030fa5d4750539f53.pdf";